import { useMemo } from "react";

const ITEMS_TO_SHOW = 10;
const MIN_ITEMS_FOR_SEARCH = 11;

/**
 * Determines whether to show search and "Show More" in the key message filter.
 * @param filteredCount - Filtered items count based on search
 * @param totalCount - Total number of filter items
 * @param hasActiveSearch - Whether the user has typed in the search box
 */
export const useFilterVisibility = (
  filteredCount: number,
  totalCount: number,
  hasActiveSearch = false,
) =>
  useMemo(() => {
    const needsShowMore = filteredCount > ITEMS_TO_SHOW;
    const showSearch = totalCount > MIN_ITEMS_FOR_SEARCH || hasActiveSearch;
    return {
      needsShowMore,
      showSearch,
    };
  }, [filteredCount, totalCount, hasActiveSearch]);
